import React from 'react';
import { Link } from 'react-router-dom';
import styles from './FoodyButton.module.css';

export interface FoodyButtonProps {
  variant?: 'primary' | 'secondary' | 'outline' | 'gray';
  fullWidth?: boolean;
  className?: string;
  children?: React.ReactNode;
  as?: 'button' | 'submit' | 'link';
  to?: string;
  value?: string;
  disabled?: boolean;
  onClick?: React.MouseEventHandler;
  type?: 'button' | 'submit' | 'reset';
  style?: React.CSSProperties;
  'data-test'?: string;
}

export function FoodyButton({
  variant = 'primary',
  fullWidth = false,
  className = '',
  children,
  as,
  to,
  value,
  disabled,
  onClick,
  type,
  style,
  ...rest
}: FoodyButtonProps) {
  const cn = [
    styles.button,
    styles[variant],
    fullWidth ? styles.fullWidth : '',
    className,
  ].filter(Boolean).join(' ');

  if (as === 'link' && to) {
    return <Link className={cn} to={to} onClick={onClick} style={style} {...rest}>{children}</Link>;
  }

  if (as === 'submit' || type === 'submit') {
    return (
      <input
        type="submit"
        className={cn}
        value={value ?? (typeof children === 'string' ? children : undefined)}
        disabled={disabled}
        onClick={onClick}
        style={style}
        {...rest}
      />
    );
  }

  return (
    <button
      type={type ?? 'button'}
      className={cn}
      disabled={disabled}
      onClick={onClick}
      style={style}
      {...rest}
    >
      {children}
    </button>
  );
}
